import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import AuthService from '../services/AuthService'
import useNotification from '../hooks/useNotification'
import { resetSeenLevelsOnLogin } from '../contexts/OnboardingContext'

const OAuthCallbackPage = () => {
  const { t } = useTranslation('auth')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { error: showError } = useNotification()

  useEffect(() => {
    const apriSessione = async (token) => {
      try {
        // Il token va al backend, che risponde con il cookie HttpOnly: qui
        // non si scrive niente in document.cookie.
        await AuthService.openSession(token)
      } catch (e) {
        console.error('[OAuthCallback] scambio token fallito', e)
        showError(t('oauth.toast.error'))
        navigate('/login')
        return
      }
      resetSeenLevelsOnLogin()
      window.location.replace(`/?_t=${Date.now()}`)
    }

    // Il token arriva nel FRAGMENT (#token=): il frammento non viene inviato
    // al server, quindi non finisce nell'access log di nginx ne' in quello di
    // un proxy davanti — nella query ci restava scritta una credenziale viva
    // un'ora. La query si continua a leggere perche' portale e backend non si
    // rilasciano nello stesso istante.
    const hashParams = new URLSearchParams(window.location.hash.slice(1))
    const token = hashParams.get('token') || searchParams.get('token')
    const error = hashParams.get('error') || searchParams.get('error')
    const mfaToken =
      hashParams.get('mfa_token') || searchParams.get('mfa_token')

    if (mfaToken) {
      // MFA required after OAuth login — redirect to challenge page
      sessionStorage.setItem('mfa_token', mfaToken)
      navigate('/mfa-challenge')
      return
    }

    if (error) {
      // Show error message and redirect to login
      showError(error)
      navigate('/login')
    } else if (token) {
      apriSessione(token)
    } else {
      // No token and no error - something went wrong
      showError(t('oauth.toast.error'))
      navigate('/login')
    }
  }, [searchParams, navigate, showError, t])

  return (
    <div className="flex items-center justify-center min-h-screen bg-dark-blue">
      <div className="text-white text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-lg">{t('oauth.completing')}</p>
      </div>
    </div>
  )
}

export default OAuthCallbackPage
